"use client";

import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, CircularProgress } from '@mui/material';
import { useTranslations } from 'next-intl';
import React from 'react';
import { colors, typography } from '@/theme/colors';
interface RevokeKeyDialogProps {
  open: boolean;
  keyName: string;
  keyPrefix: string;
  onCancel: () => void;
  onConfirm: () => void;
  isLoading: boolean;
}
const RevokeKeyDialog: React.FC<RevokeKeyDialogProps> = ({
  open,
  keyName,
  keyPrefix,
  onCancel,
  onConfirm,
  isLoading
}) => {
  const t = useTranslations('apiKeys');
  return <Dialog open={open} onClose={isLoading ? undefined : onCancel} maxWidth="xs" fullWidth PaperProps={{
    sx: {
      borderRadius: '12px'
    }
  }} data-sentry-element="Dialog" data-sentry-component="RevokeKeyDialog" data-sentry-source-file="RevokeKeyDialog.tsx">
      <DialogTitle sx={{
      ...typography.presets.sectionTitle
    }} data-sentry-element="DialogTitle" data-sentry-source-file="RevokeKeyDialog.tsx">
        {t('revokeConfirmTitle')}
      </DialogTitle>
      
      <DialogContent data-sentry-element="DialogContent" data-sentry-source-file="RevokeKeyDialog.tsx">
        <Typography sx={{
        ...typography.presets.bodyDefault,
        color: colors.text.tertiary
      }} data-sentry-element="Typography" data-sentry-source-file="RevokeKeyDialog.tsx">
          {t('revokeConfirmBody')}
        </Typography>
        <Typography sx={{
        ...typography.presets.bodyDefault,
        color: colors.text.primary,
        mt: 2,
        fontWeight: 500
      }} data-sentry-element="Typography" data-sentry-source-file="RevokeKeyDialog.tsx">
          <strong>{keyName}</strong>{' '}
          <Typography component="span" sx={{
          fontFamily: 'monospace',
          fontSize: '13px',
          color: colors.text.tertiary
        }} data-sentry-element="Typography" data-sentry-source-file="RevokeKeyDialog.tsx">
            ({keyPrefix})
          </Typography>
        </Typography>
      </DialogContent>
      
      <DialogActions sx={{
      px: 3,
      pb: 3,
      gap: 1
    }} data-sentry-element="DialogActions" data-sentry-source-file="RevokeKeyDialog.tsx">
        <Button onClick={onCancel} disabled={isLoading} sx={{
        textTransform: 'none',
        minWidth: '44px',
        minHeight: '44px',
        color: colors.text.tertiary
      }} data-sentry-element="Button" data-sentry-source-file="RevokeKeyDialog.tsx">
          {t('cancel')}
        </Button>
        <Button onClick={onConfirm} disabled={isLoading} variant="contained" sx={{
        textTransform: 'none',
        minWidth: '44px',
        minHeight: '44px',
        bgcolor: colors.status.error.main,
        transition: 'all 0.15s ease',
        '&:hover': {
          bgcolor: colors.status.error.dark
        },
        '&:active': {
          transform: 'scale(0.97)'
        }
      }} data-sentry-element="Button" data-sentry-source-file="RevokeKeyDialog.tsx">
          {isLoading ? <CircularProgress size={20} sx={{
          color: 'white'
        }} /> : t('revokeKey')}
        </Button>
      </DialogActions>
    </Dialog>;
};
export default RevokeKeyDialog;